// Results gallery filters (templates/_gallery.twig): instant, no page reload, like the original Craft gallery.
// The live filter bar (FilterBar.js) emits `filterbar:change` with { key: [values] }; tiles carry data-<key> values
// separated by "|", and an option value may also list several values ("a|b", duplicate procedures shown once).
// Within a group any selected value matches; across groups all must. Hides non-matching patient tiles, re-spaces the
// interleaved CTA blocks (one after every few visible patients, via CSS order) and updates each option's count to
// what it would show under the other active filters.
(function() {
    var CTA_EVERY = 4;

    function setupGallery(gallery) {
        var form = gallery.querySelector('[data-filterbar]');
        var items = Array.prototype.slice.call(gallery.querySelectorAll('.ds-patients__item'));
        var ctas = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-cta]'));
        var empty = gallery.querySelector('[data-gallery-empty]');
        var inputs = form ? Array.prototype.slice.call(form.querySelectorAll('[data-dropdown] input[name$="[]"]')) : [];

        function valuesOf(item, key) {
            return (item.getAttribute('data-' + key) || '').split('|').filter(Boolean);
        }

        function matchesGroup(item, key, wanted) {
            if ( !wanted || wanted.length === 0 ) {
                return true;
            }
            var have = valuesOf(item, key);
            return wanted.some(function(value) {
                return value.split('|').some(function(v) { return have.indexOf(v) > -1; });
            });
        }

        function matches(item, state, skipKey) {
            return Object.keys(state).every(function(key) {
                return key === skipKey || !Array.isArray(state[key]) || matchesGroup(item, key, state[key]);
            });
        }

        function apply(state) {
            var visible = 0;
            var ctaIndex = 0;
            items.forEach(function(item) {
                var show = matches(item, state);
                item.hidden = !show;
                if ( show ) {
                    visible++;
                    item.style.order = visible * 2;
                }
            });
            // A CTA after every CTA_EVERY visible patients, never after the last one.
            for ( var position = CTA_EVERY; position < visible && ctaIndex < ctas.length; position += CTA_EVERY ) {
                ctas[ctaIndex].hidden = false;
                ctas[ctaIndex].style.order = position * 2 + 1;
                ctaIndex++;
            }
            for ( ; ctaIndex < ctas.length; ctaIndex++ ) {
                ctas[ctaIndex].hidden = true;
            }
            if ( empty ) {
                empty.hidden = visible > 0;
                empty.style.order = 0;
            }

            if ( form && form.filterBar ) {
                form.filterBar.setCount(visible + (visible == 1 ? ' patient' : ' patients'));
                inputs.forEach(function(input) {
                    var key = input.name.replace(/\[\]$/, '');
                    var count = items.filter(function(item) {
                        return matches(item, state, key) && matchesGroup(item, key, [input.value]);
                    }).length;
                    form.filterBar.setOptionCount(input, count);
                });
            }
            if ( window.lazyLoadInstance ) {
                window.lazyLoadInstance.update();
            }
        }

        if ( form ) {
            form.addEventListener('filterbar:change', function(event) {
                apply(event.detail.state);
            });
            if ( form.filterBar ) {
                apply(form.filterBar.state());
            }
        }
    }

    document.addEventListener('DOMContentLoaded', function() {
        document.querySelectorAll('[data-gallery]').forEach(setupGallery);
    });
})();
